<template>
  <div class="wrap">
    <div class="card-face-container">
      <img class="card-bg" src="../img/cardnewbg.png" alt="" />
      <div class="card-top-info">
        <div class="card-top-org">XX省(市)卫生健康委员会</div>
        <div class="card-top-title">
          <img src="../img/icon2.png" alt="" />
          <span>电子健康卡</span>
        </div>
      </div>
      <div class="card-detail-info">
        <div class="card-user-info">
          <span class="card-user-name">用户姓名</span>
          <span class="card-user-id">4401**********4224</span>
        </div>
        <div class="card-qrcode">
          <img class="card-qrcode-logo" src="../img/logo_.png" alt="" />
          <img src="../img/qrcode.png" alt="" />
        </div>
      </div>

      <div class="card-footer">中华人民共和国国家卫生健康委员会监制</div>
    </div>
  </div>
</template>

<script >
export default {};
</script>

<style lang="scss" scoped>

</style>